import Echo from 'laravel-echo';
import io from 'socket.io-client';
import { SOCKET_URL } from './constants';

const echo = new Echo({
  broadcaster: 'socket.io',
  host: SOCKET_URL,
  client: io,
  transports: ['websocket'],
  forceTLS: false,
  disableStats: true,
});

window.Echo = echo;

echo.connector.socket.on('connect', () => {
  console.log('Realtime connection established.');
});

echo.connector.socket.on('connect_error', (error) => {
  console.error('Realtime connection error:', error.message);
});

export default echo;
